export const config = {
  "url_prefix" : "https://ar.mochi.gdn",
  "self_url" : "https://menus.ar.mochi.gdn",
  "debug": true
}

